import util from '@bmp-vue/core/api/util'

const controller = 'OperadorMfa'
export default Object.assign({}, util.GetCrud(controller, null), {
  SolicitacaoEmAberto: function (codigo) {
    return util.Axios.Get(controller + `/${codigo}/solicitacoes-em-aberto`)
  },
  SolicitarMfa: function () {
    return util.Axios.Post(controller)
  },
  ValidarMfaSmsEmail: function (dto, headers) {
    return util.Axios.Post(controller + '/ValidarMfaSmsEmail', dto, headers)
  },
  GenerateMfa: function (dto) {
    return util.Axios.Post(controller + '/GenerateMfa', dto)
  },
  EnviarSMS: function (dto) {
    return util.Axios.Post(controller + '/SMS', dto)
  },
  EnviarEmail: function (dto) {
    return util.Axios.Post(controller + '/Email', dto)
  },
  OperadorTemMfaValido: function () {
    return util.Axios.Get(controller + '/OperadorTemMfaValido')
  },
  ValidarTokenMfa: function (headers) {
    return util.Axios.Post(controller + '/ValidarTokenMfa', null, headers)
  },
  RevogarMfa: function(codigo){
    return util.Axios.Post(controller + `/DesativarMfaRetaguarda?codigoOperadorRetaguarda=${codigo}`, {})
  }
})